import { Component, OnInit, OnDestroy } from '@angular/core';
import { Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store, Select, Actions, ofActionSuccessful } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { AuthState } from '../core/auth/auth.state';
import { startWith, takeUntil } from 'rxjs/operators';
import { StateMessage } from '../core/state.types';
import { NavigateAfterLogin, Login } from '@oneapp/core/auth/auth.actions';
import { LoginDataCySelector } from './login.models';

@Component({
    selector: 'oa-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
    @Select(AuthState.isLoggingIn) public isLoggingIn$: Observable<boolean>;
    @Select(AuthState.authStatusMessage) public authStatusMessage$: Observable<StateMessage>;

    public loginForm = new UntypedFormGroup({
        username: new UntypedFormControl('', [Validators.required]),
        password: new UntypedFormControl('', Validators.required)
    });

    public submitDisabled$: Observable<boolean>;
    public translateServiceLoaded$: Observable<boolean>;

    public dataCySelectors = LoginDataCySelector;

    private _destroy$: Subject<boolean> = new Subject();

    constructor(
        private _store: Store,
        private _actions: Actions
    ) { }

    public ngOnInit() {
        document.dispatchEvent(new Event('appready'));

        this.submitDisabled$ = this.isLoggingIn$.pipe(
            startWith(true)
        );

        this._actions.pipe(
            ofActionSuccessful(Login),
            takeUntil(this._destroy$)
        ).subscribe(() => {
            this._store.dispatch(new NavigateAfterLogin());
        });
    }

    public ngOnDestroy() {
        this._destroy$.next(true);
        this._destroy$.complete();
    }

    public onSubmit() {
        if (!this.loginForm.valid) {
            return;
        }
        this._store.dispatch(new Login(this.loginForm.value));
    }
}
